import type { Pack } from "@/modules/corporate/types/pricing"
import type { FunctionComponent } from "react"

import { clsx } from "clsx"

import styles from "./ColGroup.module.css"

type ColGroupProps = {
  packs: Pack[]
}

export const ColGroup: FunctionComponent<ColGroupProps> = ({ packs }) => {
  const colClassName = (id: Pack["id"]): string => clsx(styles.packCol, { [styles[`packCol--${id}`]]: !!id })

  return (
    <colgroup>
      <col className={styles.featuresCol} />
      {packs.map(pack => (
        <col key={pack.id} className={colClassName(pack.id)} />
      ))}
    </colgroup>
  )
}
